<template>
  <div class=""></div>
</template>
<script>
import { personaCfg, persona } from '@ciitizen/api'
import Persona from 'persona'

export default {
  name: 'Persona',
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      personaClient: null
    }
  },
  mounted() {
    if (this.userId) {
      this.initPersonaClient()
    }
  },
  methods: {
    initPersonaClient() {
      const vm = this
      if (this.personaClient === null) {
        this.personaClient = new Persona.Client({
          templateId: personaCfg.templateId,
          environment: personaCfg.env,
          referenceId: vm.userId,
          onComplete: async ({ inquiryId, status }) => {
            await persona.fetchId(inquiryId)
            await vm.onIdentificationComplete()
          }
        })
      }
    },
    open() {
      this.personaClient.open()
    },
    async onIdentificationComplete() {
      try {
        this.$emit('identificationComplete')
      } catch (err) {
        error(err)
      } finally {
        this.$emit('loading', false)
      }
    }
  }
}
</script>
